<template>
  <a-modal
    :visible="visible"
    :title="$t('action.clone')"
    :footer="false"
    width="50%"
    @cancel="$emit('cancel')"
  >
    <a-form @submit="handleSubmit">
      <a-form-item :label="$t('college.bulletin.config.from')">
        <a-row :gutter="16">
          <a-col :span="8">
            <a-select
              v-model="localSourceLevel"
              :placeholder="$t('college.bulletin.config.niveau')"
              style="width: 100%"
            >
              <a-select-option
                v-for="(value, level) in levelSelectData"
                :key="level"
                :value="level"
              >
                {{ value }}
              </a-select-option>
            </a-select>
          </a-col>
          <a-col :span="8">
            <a-select
              v-model="localSourceTrim"
              :placeholder="$t('emploi.trimestre')"
              style="width: 100%"
            >
              <a-select-option
                v-for="trim in trimesters"
                :key="trim"
                :value="trim"
              >
                {{ trim }}
              </a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-form-item>

      <a-form-item :label="$t('college.bulletin.config.to')">
        <a-row :gutter="16">
          <a-col :span="12">
            <a-select
              :value="localTargetLevels"
              mode="multiple"
              :placeholder="$t('college.bulletin.config.niveaux')"
              @change="localTargetLevels = $event"
              style="width: 100%"
            >
              <a-select-option
                v-for="(value, level) in levelSelectData"
                :key="level"
                :value="parseInt(level)"
              >
                {{ value }}
              </a-select-option>
            </a-select>
          </a-col>
          <a-col :span="12">
            <a-select
              :value="localTargetTrims"
              mode="multiple"
              :placeholder="$t('college.bulletin.config.trimestres')"
              @change="localTargetTrims = $event"
              style="width: 100%"
            >
              <a-select-option
                v-for="trim in trimesters"
                :key="trim"
                :value="trim"
              >
                {{ trim }}
              </a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-form-item>

      <div class="form-actions mt-3">
        <a-button
          type="primary"
          htmlType="submit"
          :loading="loading"
          :disabled="!isValid || isReadOnly"
          class="mr-3"
        >
          {{ $t("action.clone") }}
        </a-button>
        <a-button @click="$emit('cancel')" :disabled="loading || isReadOnly">
          {{ $t("action.annuler") }}
        </a-button>
      </div>
    </a-form>
  </a-modal>
</template>

<script>
export default {
  name: "CloneModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    sourceLevel: {
      type: String,
      required: true,
    },
    sourceTrim: {
      type: String,
      required: true,
    },
    targetLevels: {
      type: Array,
      default: () => [],
    },
    targetTrims: {
      type: Array,
      default: () => [],
    },
    levelSelectData: {
      type: Object,
      required: true,
    },
    trimesters: {
      type: Array,
      default: () => ["1", "2", "3"],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localSourceLevel: this.sourceLevel,
      localSourceTrim: this.sourceTrim,
      localTargetLevels: [...this.targetLevels],
      localTargetTrims: [...this.targetTrims],
    };
  },
  computed: {
    isValid() {
      return (
        this.localSourceLevel &&
        this.localSourceTrim &&
        this.localTargetLevels.length > 0 &&
        this.localTargetTrims.length > 0
      );
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.localSourceLevel = this.sourceLevel;
        this.localSourceTrim = this.sourceTrim;
        this.localTargetLevels = [...this.targetLevels];
        this.localTargetTrims = [...this.targetTrims];
      }
    },
    sourceLevel(val) {
      this.localSourceLevel = val;
    },
    sourceTrim(val) {
      this.localSourceTrim = val;
    },
    targetLevels(val) {
      this.localTargetLevels = [...val];
    },
    targetTrims(val) {
      this.localTargetTrims = [...val];
    },
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      const payload = {
        from: {
          level: parseInt(this.localSourceLevel),
          trimester: parseInt(this.localSourceTrim),
        },
        to: {
          levels: this.localTargetLevels,
          trimesters: this.localTargetTrims.map((t) => parseInt(t)),
          //can add sy later
        },
      };
      this.$emit("submit", payload);
    }
  }
};
</script>
